import { Location } from '@angular/common';
import { Component, Input } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: '[miq-go-back-link]',
  template: `
    <span (click)="back()"><mat-icon *ngIf="!hideIcon">arrow_back</mat-icon> <ng-content></ng-content></span>
  `,
  standalone: false,
})
export class GoBackLinkComponent {
  @Input() withRoute: string[];
  @Input() hideIcon = false;

  constructor(
    private location: Location,
    private router: Router
  ) {}

  back() {
    if (!this.withRoute) {
      this.location.back();
    } else {
      this.router.navigate(this.withRoute);
    }
  }
}
